module.exports = __webpack_public_path__ + "img/facebook.7e8f3478.svg";